import CourseMap from '../../../api/CourseMap';

export const store = async (context, { params }) => {
    return await new CourseMap().store(params);
};

export default {
    store,
};



// WEBPACK FOOTER //
// ./src/store/modules/courseMap/actions.js